function debug (...info) {
  if (dev()) {
    console.log(...info)
  }
}

function debugError (...info) {
  if (dev()) {
    console.error(...info)
  }
}

function dev () {
  return process.env.NODE_ENV === 'development'
}

export { debug, debugError }
